module.exports = __webpack_public_path__ + "submenu_index_1.a748ea74.png";